import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.peop_user_assigned_uid !== model.peop_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.peop_user_modified_uid,
						assignedTo: modifiedModel.peop_user_assigned_uid,
						title: 'Nuova Persona assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.peop_title}".`,
						url: `${window.location.origin}/people/details/${model.peop_uid}`,
						icon: 'card-account-details-outline',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
